import React from "react";
import {
  Col,
  ControlLabel,
  FormGroup,
  Button,
  Glyphicon,
} from "react-bootstrap";
import { Field, ErrorMessage } from "formik";
import { Typeahead } from "react-bootstrap-typeahead";
import "./styles.css";

export const MultilpleSelectAutoComplete = ({
  name,
  label,
  col,
  options,
  addNewOption,
  ...props
}) => {
  return (
    <Field name={name} multiple>
      {({ field, form: { setFieldValue, touched, errors, values } }) => (
        <FormGroup
          controlId={name}
          validationState={
            touched[name] && touched[name][0] && errors[name] ? "error" : null
          }
        >
          <Col componentClass={ControlLabel} sm={label.col}>
            {label.text}{" "}
            {addNewOption && (
              <Button bsSize="xs" bsStyle="success" onClick={addNewOption}>
                <Glyphicon glyph="plus" />
              </Button>
            )}
          </Col>
          <Col className="repeater" sm={col}>
            {options && options.length > 0 ? (
              <Typeahead
                {...props}
                multiple
                defaultSelected={
                  values[name].length === 1 && values[name][0] === ""
                    ? []
                    : options.filter((option) =>
                        values[name].includes(option.id)
                      )
                }
                onChange={(selected) => {
                  const selectedOptions = selected.map((option) => option.id);
                  field.onChange(selectedOptions);
                  setFieldValue(name, selectedOptions);
                }}
                options={options}
              />
            ) : (
              <span>
                <i className="fa fa-spinner fa-spin" />
              </span>
            )}
            {!props.disabled && (
              <span>Type into the field to search a feature.</span>
            )}
            <ErrorMessage
              component="div"
              className="error text-danger"
              name={name}
            />
          </Col>
        </FormGroup>
      )}
    </Field>
  );
};
